import React, { useContext, useState } from "react";
import { images } from "../../Assets/images";
import { GlobalContext } from "../../Context/GlobalContext";

const FourLifeLogin = () => {
    const { fourLifeuserData, setFourLifeUserData, logoUrl, translatedLabels, showPasswords, togglePassword, fourLifeUserLogin } = useContext(GlobalContext);
    const authLabel = translatedLabels?.auth;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFourLifeUserData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fourLifeUserLogin();
    };

    return (
        <div className="login-section-bg">
            <div className="container-main">
                <div className="d-flex justify-content-center">
                    <div className="app-logo">
                        <img
                            src={logoUrl || images.appLogo}
                            alt="app-logo"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = images.appLogo;
                            }}
                        />
                    </div>
                </div>
                <div className="alert alert-warning py-1 px-2 mt-3 fs-15px">
                    {authLabel?.enter_only_your_4life_account_username_and_password?.label_value || "Enter only your 4Life account username and password."}
                </div>
                <p></p>
                <h3 className="mb-0 text-center">
                    {authLabel?.welcome_back?.label_value || "Welcome Back!"}
                </h3>
                <form onSubmit={handleSubmit} className="mt-4">
                    <div className="mb-3">
                        <label className="form-label">
                            {authLabel?.user_name?.label_value || "Username"} <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            name="userName"
                            className="form-control"
                            placeholder="Enter your email"
                            value={fourLifeuserData.userName}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="position-relative">
                        <label className="form-label">
                            {authLabel?.password?.label_value || "Login"} <span className="text-danger">*</span>
                        </label>

                        <input
                            type={showPasswords?.field1 ? "text" : "password"}
                            name="password"
                            className="form-control wrInputText"
                            placeholder={
                                authLabel?.enter_password?.label_value || "Enter Password"
                            }
                            value={fourLifeuserData.password}
                            onChange={handleChange}
                        />

                        <span
                            className="toggle-password position-absolute eye-icon"
                            onClick={() => togglePassword("field1")}
                        >
                            <i
                                className={`fa ${showPasswords?.field1 ? "fa-eye" : "fa-eye-slash"
                                    }`}
                            ></i>
                        </span>
                    </div>

                    <div className="mt-5 text-center">
                        <button type="submit" className="btn btn-primary">
                            {authLabel?.login?.label_value || "Login"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FourLifeLogin;